import { useState } from "react";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import Button from "../../../../Elements/Button/Button.js";
import Dropdown from "../../../../Elements/Dropdown/Dropdown.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { BankNameAndIds } from "../Utils/Helper.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";

const AddBankModal = ({
  editDetails,
  isEdit = false,
  banksAccount,
  setBanksAccount,
  index,
}) => {
  const banksList = BankNameAndIds
    ? BankNameAndIds.map((bank) => {
        return bank.name + " - " + bank.id;
      })
    : [];
  const bankNameEdit =
    isEdit && editDetails
      ? BankNameAndIds.find((s) => s.id === editDetails.BankId)
      : null;
  const bankIdAndNameEdit = bankNameEdit
    ? bankNameEdit.name + " - " + bankNameEdit.id
    : null;
  const { closeModal } = useModal();
  const { getTextByKey } = useContent();
  const [accountName, setAccountName] = useState(
    isEdit && editDetails ? editDetails.BankOwnerName : ""
  );
  const [bankName, setBankName] = useState(
    !isEdit ? banksList[0] : bankIdAndNameEdit
  );
  const [branch, setBranch] = useState(
    isEdit && editDetails ? editDetails.BankBranchId : ""
  );
  const [accountNo, setAccountNo] = useState(
    isEdit && editDetails ? editDetails.BankAccountId : ""
  );

  const handleChange = (e, itemKey) => {
    setBankName(banksList[itemKey]);
  };

  const handleSubmit = () => {
    const bankId = bankName.split(" - ")[1];
    let body = {
      entryId: isEdit ? Number(index) : 0,
      delete: false,
      BankBranchId: branch,
      BankAccountId: accountNo,
      BankOwnerName: accountName,
      BankId: bankId,
      defaultBank: false,
    };
    addBankToApi(body);
  };

  const addBankToApi = async (body) => {
    const response = await apiRequest(
      "Users",
      "SetBankAccountDetailsReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        let newBanksAccount = [...banksAccount];
        if (isEdit) {
          const listIndex = newBanksAccount.indexOf(
            newBanksAccount.find((item) => item.keyIndex === index)
          );
          newBanksAccount[listIndex] = body;
        } else {
          let newBank = { body };
          let lastBank = newBanksAccount[newBanksAccount.length - 1];
          if (lastBank) {
            newBank.keyIndex = Number(lastBank.keyIndex) + 1;
          } else {
            newBank.keyIndex = 1;
          }
          newBanksAccount.push(newBank);
        }
        setBanksAccount(newBanksAccount);
        closeModal();
      }
    }
  };

  return (
    <div className="add-bank-modal">
      <div className="add-bank-modal-header">
        <h3>{getTextByKey(isEdit ? "edit-bank" : "add-bank")}</h3>
      </div>
      <div className="add-bank-modal-content">
        <div className="add-bank-modal-input-container">
          <div className="input-div account-name">
            <span className="input-span">{getTextByKey("account-name")}</span>
            <input
              type="text"
              value={accountName}
              onChange={(e) => setAccountName(e.target.value)}
            />
          </div>
          {bankName && (
            <div className="input-div bank-name">
              <span className="input-span">{getTextByKey("bank-name")}</span>
              <Dropdown
                title={bankName}
                handleChange={handleChange}
                selectList={banksList}
                defaultValue={bankName}
              >
                <div className="">
                  <Icon name="arrow-down-solid" small />
                </div>
              </Dropdown>
            </div>
          )}
          <div className="branch-and-account-no">
            <div className="input-div branch">
              <span className="input-span">{getTextByKey("branch")}</span>
              <input
                type="text"
                value={branch}
                onChange={(e) => setBranch(e.target.value)}
              />
            </div>
            <div className="input-div account-no">
              <span className="input-span">{getTextByKey("account-no")}</span>
              <input
                type="text"
                value={accountNo}
                onChange={(e) => setAccountNo(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="submit-container">
          <Button onClick={() => handleSubmit()}>{getTextByKey("ok")}</Button>
        </div>
      </div>
    </div>
  );
};

export default AddBankModal;
